const React = require('react');

const {
    useRef,
    useState,
    useCallback,
    useEffect
} = React;

module.exports = function useElementSize(externalRef) {

    const internalRef = useRef(null);
    const ref = externalRef || internalRef;

    const [size, setSize] = useState({ width: 0, height: 0 });

    const fallbackCallbackRef = useCallback((node) => {

        internalRef.current = node;
    }, []);

    useEffect(() => {

        const node = ref.current;
        if (!node) {
            return;
        }

        const ro = new ResizeObserver(([entry]) => {

            const { width, height } = entry.contentRect;
            setSize({ width, height });
        });

        ro.observe(node);

        return () => ro.disconnect();
    }, [ref]);

    return [size, externalRef ? ref : fallbackCallbackRef];
};
